export default __webpack_public_path__ + "media/images/banners/months/bnr_12-2c6e6ffaed9dfc49b677b3f88c3a8241.jpg";